// src/features/auth/selectors.ts
import type { RootState } from '@/store'

// Single source of truth for "which token authorizes API requests".
// Used by both prepareHeaders (src/api/client.ts) and useMe's skip guard —
// they must never disagree, or /users/me fires without an Authorization
// header (a guaranteed 401 feeding the refresh cascade).
export const selectAuthToken = (state: RootState): string =>
  state.authTokens.accessToken || state.dev.pastedJwt
